// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__7B-j9","footer":"ModalInfo_footer__QzO2k"};